import { render, staticRenderFns } from "./PosturesByDepurationReasonModal.vue?vue&type=template&id=c5e4fb18"
import script from "./PosturesByDepurationReasonModal.vue?vue&type=script&lang=js"
export * from "./PosturesByDepurationReasonModal.vue?vue&type=script&lang=js"
import style0 from "./PosturesByDepurationReasonModal.vue?vue&type=style&index=0&id=c5e4fb18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports